import { useMemo } from 'react'

import { cn } from '@/lib/utils'

const TruncatedFileNameDisplay = ({
  fileName,
  className,
  secondNameCharacterCount = 4,
  classNames,
}: {
  fileName: string
  className?: string
  secondNameCharacterCount?: number
  classNames?: {
    firstName?: string
    secondName?: string
    extension?: string
  }
}) => {
  const [firstName, secondName, extension] = useMemo(() => {
    const lastPeriodIndex = fileName.lastIndexOf('.')

    let name = ''
    let firstName = ''
    let secondName = ''
    let extension = ''

    if (lastPeriodIndex > 0) {
      name = fileName.slice(0, lastPeriodIndex)
      extension = fileName.slice(lastPeriodIndex)
    }

    if (name.length > secondNameCharacterCount) {
      firstName = name.slice(0, name.length - secondNameCharacterCount)
      secondName = name.slice(-secondNameCharacterCount)
    } else {
      firstName = name
    }

    return [firstName, secondName, extension]
  }, [fileName, secondNameCharacterCount])

  return (
    <p className={cn('flex flex-nowrap items-center gap-0 truncate', className)} title={fileName}>
      <span className={cn('truncate whitespace-pre', classNames?.firstName)}>{firstName}</span>
      {secondName && <span className={cn('shrink-0 whitespace-pre', classNames?.secondName)}>{secondName}</span>}
      {extension && <span className={cn('shrink-0 whitespace-pre', classNames?.extension)}>{extension}</span>}
    </p>
  )
}
TruncatedFileNameDisplay.displayName = 'TruncatedFileNameDisplay'

export { TruncatedFileNameDisplay }
